// ─── GBCOSPACK — locale-aware PDF font registration ─────────────────────────
// Registers ONLY the font family needed for the document locale. The heavy CJK
// font assets are code-split behind per-locale dynamic imports, so:
//   - en     → no registration (Helvetica is built into @react-pdf)
//   - ko     → loads only NotoSansKR
//   - zh-CN  → loads only NotoSansSC

import type { DocumentLocale } from '@/quotation/document/types';

export async function registerPdfFontsForLocale(
  locale: DocumentLocale,
): Promise<void> {
  if (locale === 'ko') {
    const { registerKoreanPdfFont } = await import('./korean');
    registerKoreanPdfFont();
  } else if (locale === 'zh-CN') {
    const { registerChinesePdfFont } = await import('./chinese');
    registerChinesePdfFont();
  }
  // 'en' uses Helvetica (built-in) — nothing to register.
}